export const keyWords: { [language: string]: string[] } = {
	en: [
		'i',
		'me',
		'my',
		'myself',
		'we',
		'our',
		'ours',
		'ourselves',
		'you',
		"you're",
		"you've",
		"you'll",
		"you'd",
		'your',
		'yours',
		'yourself',
		'yourselves',
		'he',
		'him',
		'his',
		'himself',
		'she',
		"she's",
		'her',
		'hers',
		'herself',
		'it',
		"it's",
		'its',
		'itself',
		'they',
		'them',
		'their',
		'theirs',
		'themselves',
		'what',
		'which',
		'who',
		'whom',
		'this',
		'that',
		"that'll",
		'these',
		'those',
		'am',
		'is',
		'are',
		'was',
		'were',
		'be',
		'been',
		'being',
		'have',
		'has',
		'had',
		'having',
		'do',
		'does',
		'did',
		'doing',
		'a',
		'an',
		'the',
		'and',
		'but',
		'if',
		'or',
		'because',
		'as',
		'until',
		'while',
		'of',
		'at',
		'by',
		'for',
		'with',
		'about',
		'against',
		'between',
		'into',
		'through',
		'during',
		'before',
		'after',
		'above',
		'below',
		'to',
		'from',
		'up',
		'down',
		'in',
		'out',
		'on',
		'off',
		'over',
		'under',
		'again',
		'further',
		'then',
		'once',
		'here',
		'there',
		'when',
		'where',
		'why',
		'how',
		'all',
		'any',
		'both',
		'each',
		'few',
		'more',
		'most',
		'other',
		'some',
		'such',
		'no',
		'nor',
		'not',
		'only',
		'own',
		'same',
		'so',
		'than',
		'too',
		'very',
		'can',
		'will',
		'just',
		'don',
		"don't",
		'should',
		"should've",
		'now',
		'ain',
		'aren',
		"aren't",
		'couldn',
		"couldn't",
		'didn',
		"didn't",
		'doesn',
		"doesn't",
		'hadn',
		"hadn't",
		'hasn',
		"hasn't",
		'haven',
		"haven't",
		'isn',
		"isn't",
		'ma',
		'mightn',
		"mightn't",
		'mustn',
		"mustn't",
		'needn',
		"needn't",
		'shan',
		"shan't",
		'shouldn',
		"shouldn't",
		'wasn',
		"wasn't",
		'weren',
		"weren't",
		'won',
		"won't",
		'wouldn',
		"wouldn't",
	],
	de: [
		'de',
		'en',
		'van',
		'ik',
		'te',
		'dat',
		'die',
		'in',
		'een',
		'hij',
		'het',
		'niet',
		'zijn',
		'is',
		'was',
		'op',
		'aan',
		'met',
		'als',
		'voor',
		'had',
		'er',
		'maar',
		'om',
		'hem',
		'dan',
		'zou',
		'of',
		'wat',
		'mijn',
		'men',
		'dit',
		'zo',
		'door',
		'over',
		'ze',
		'zich',
		'bij',
		'ook',
		'tot',
		'je',
		'mij',
		'uit',
		'der',
		'daar',
		'haar',
		'naar',
		'heb',
		'hoe',
		'heeft',
		'hebben',
		'deze',
		'u',
		'want',
		'nog',
		'zal',
		'me',
		'zij',
		'nu',
		'ge',
		'geen',
		'omdat',
		'iets',
		'worden',
		'toch',
		'al',
		'waren',
		'veel',
		'meer',
		'doen',
		'toen',
		'moet',
		'ben',
		'zonder',
		'kan',
		'hun',
		'dus',
		'alles',
		'onder',
		'ja',
		'eens',
		'hier',
		'wie',
		'werd',
		'altijd',
		'doch',
		'wordt',
		'wezen',
		'kunnen',
		'ons',
		'zelf',
		'tegen',
		'na',
		'reeds',
		'wil',
		'kon',
		'niets',
		'uw',
		'iemand',
		'geweest',
		'andere',
	],
	ru: [
		'и',
		'в',
		'во',
		'не',
		'что',
		'он',
		'на',
		'я',
		'с',
		'со',
		'как',
		'а',
		'то',
		'все',
		'она',
		'так',
		'его',
		'но',
		'да',
		'ты',
		'к',
		'у',
		'же',
		'вы',
		'за',
		'бы',
		'по',
		'только',
		'ее',
		'мне',
		'было',
		'вот',
		'от',
		'меня',
		'еще',
		'нет',
		'о',
		'из',
		'ему',
		'теперь',
		'когда',
		'даже',
		'ну',
		'вдруг',
		'ли',
		'если',
		'уже',
		'или',
		'ни',
		'быть',
		'был',
		'него',
		'до',
		'вас',
		'нибудь',
		'опять',
		'уж',
		'вам',
		'ведь',
		'там',
		'потом',
		'себя',
		'ничего',
		'ей',
		'может',
		'они',
		'тут',
		'где',
		'есть',
		'надо',
		'ней',
		'для',
		'мы',
		'тебя',
		'их',
		'чем',
		'была',
		'сам',
		'чтоб',
		'без',
		'будто',
		'чего',
		'раз',
		'тоже',
		'себе',
		'под',
		'будет',
		'ж',
		'тогда',
		'кто',
		'этот',
		'того',
		'потому',
		'этого',
		'какой',
		'совсем',
		'ним',
		'здесь',
		'этом',
		'один',
		'почти',
		'мой',
		'тем',
		'чтобы',
		'нее',
		'сейчас',
		'были',
		'куда',
		'зачем',
		'всех',
		'никогда',
		'можно',
		'при',
		'наконец',
		'два',
		'об',
		'другой',
		'хоть',
		'после',
		'над',
		'больше',
		'тот',
		'через',
		'эти',
		'нас',
		'про',
		'всего',
		'них',
		'какая',
		'много',
		'разве',
		'три',
		'эту',
		'моя',
		'впрочем',
		'хорошо',
		'свою',
		'этой',
		'перед',
		'иногда',
		'лучше',
		'чуть',
		'том',
		'нельзя',
		'такой',
		'им',
		'более',
		'всегда',
		'конечно',
		'всю',
		'между',
	],
	fr: [
		'au',
		'aux',
		'avec',
		'ce',
		'ces',
		'dans',
		'de',
		'des',
		'du',
		'elle',
		'en',
		'et',
		'eux',
		'il',
		'ils',
		'je',
		'la',
		'le',
		'les',
		'leur',
		'lui',
		'ma',
		'mais',
		'me',
		'même',
		'mes',
		'moi',
		'mon',
		'ne',
		'nos',
		'notre',
		'nous',
		'on',
		'ou',
		'par',
		'pas',
		'pour',
		'qu',
		'que',
		'qui',
		'sa',
		'se',
		'ses',
		'son',
		'sur',
		'ta',
		'te',
		'tes',
		'toi',
		'ton',
		'tu',
		'un',
		'une',
		'vos',
		'votre',
		'vous',
		'c',
		'd',
		'j',
		'l',
		'à',
		'm',
		'n',
		's',
		't',
		'y',
		'été',
		'étée',
		'étées',
		'étés',
		'étant',
		'étante',
		'étants',
		'étantes',
		'suis',
		'es',
		'est',
		'sommes',
		'êtes',
		'sont',
		'serai',
		'seras',
		'sera',
		'serons',
		'serez',
		'seront',
		'serais',
		'serait',
		'serions',
		'seriez',
		'seraient',
		'étais',
		'était',
		'étions',
		'étiez',
		'étaient',
		'fus',
		'fut',
		'fûmes',
		'fûtes',
		'furent',
		'sois',
		'soit',
		'soyons',
		'soyez',
		'soient',
		'fusse',
		'fusses',
		'fût',
		'fussions',
		'fussiez',
		'fussent',
		'ayant',
		'ayante',
		'ayantes',
		'ayants',
		'eu',
		'eue',
		'eues',
		'eus',
		'ai',
		'as',
		'avons',
		'avez',
		'ont',
		'aurai',
		'auras',
		'aura',
		'aurons',
		'aurez',
		'auront',
		'aurais',
		'aurait',
		'aurions',
		'auriez',
		'auraient',
		'avais',
		'avait',
		'avions',
		'aviez',
		'avaient',
		'eut',
		'eûmes',
		'eûtes',
		'eurent',
		'aie',
		'aies',
		'ait',
		'ayons',
		'ayez',
		'aient',
		'eusse',
		'eusses',
		'eût',
		'eussions',
		'eussiez',
		'eussent',
	],
	pt: [
		'a',
		'à',
		'ao',
		'aos',
		'aquela',
		'aquelas',
		'aquele',
		'aqueles',
		'aquilo',
		'as',
		'às',
		'até',
		'com',
		'como',
		'da',
		'das',
		'de',
		'dela',
		'delas',
		'dele',
		'deles',
		'depois',
		'do',
		'dos',
		'e',
		'é',
		'ela',
		'elas',
		'ele',
		'eles',
		'em',
		'entre',
		'era',
		'eram',
		'éramos',
		'essa',
		'essas',
		'esse',
		'esses',
		'esta',
		'está',
		'estamos',
		'estão',
		'estar',
		'estas',
		'estava',
		'estavam',
		'estávamos',
		'este',
		'esteja',
		'estejam',
		'estejamos',
		'estes',
		'esteve',
		'estive',
		'estivemos',
		'estiver',
		'estivera',
		'estiveram',
		'estivéramos',
		'estiverem',
		'estivermos',
		'estivesse',
		'estivessem',
		'estivéssemos',
		'estou',
		'eu',
		'foi',
		'fomos',
		'for',
		'fora',
		'foram',
		'fôramos',
		'forem',
		'formos',
		'fosse',
		'fossem',
		'fôssemos',
		'fui',
		'há',
		'haja',
		'hajam',
		'hajamos',
		'hão',
		'havemos',
		'haver',
		'hei',
		'houve',
		'houvemos',
		'houver',
		'houvera',
		'houverá',
		'houveram',
		'houvéramos',
		'houverão',
		'houverei',
		'houverem',
		'houveremos',
		'houveria',
		'houveriam',
		'houveríamos',
		'houvermos',
		'houvesse',
		'houvessem',
		'houvéssemos',
		'isso',
		'isto',
		'já',
		'lhe',
		'lhes',
		'mais',
		'mas',
		'me',
		'mesmo',
		'meu',
		'meus',
		'minha',
		'minhas',
		'muito',
		'na',
		'não',
		'nas',
		'nem',
		'no',
		'nos',
		'nós',
		'nossa',
		'nossas',
		'nosso',
		'nossos',
		'num',
		'numa',
		'o',
		'os',
		'ou',
		'para',
		'pela',
		'pelas',
		'pelo',
		'pelos',
		'por',
		'qual',
		'quando',
		'que',
		'quem',
		'são',
		'se',
		'seja',
		'sejam',
		'sejamos',
		'sem',
		'ser',
		'será',
		'serão',
		'serei',
		'seremos',
		'seria',
		'seriam',
		'seríamos',
		'seu',
		'seus',
		'só',
		'somos',
		'sou',
		'sua',
		'suas',
		'também',
		'te',
		'tem',
		'tém',
		'temos',
		'tenha',
		'tenham',
		'tenhamos',
		'tenho',
		'terá',
		'terão',
		'terei',
		'teremos',
		'teria',
		'teriam',
		'teríamos',
		'teu',
		'teus',
		'teve',
		'tinha',
		'tinham',
		'tínhamos',
		'tive',
		'tivemos',
		'tiver',
		'tivera',
		'tiveram',
		'tivéramos',
		'tiverem',
		'tivermos',
		'tivesse',
		'tivessem',
		'tivéssemos',
		'tu',
		'tua',
		'tuas',
		'um',
		'uma',
		'você',
		'vocês',
		'vos',
	],
	cs: [
		'a',
		'aby',
		'ahoj',
		'aj',
		'ale',
		'anebo',
		'ani',
		'aniž',
		'ano',
		'asi',
		'aspoň',
		'atd',
		'atp',
		'az',
		'ačkoli',
		'až',
		'bez',
		'beze',
		'blízko',
		'bohužel',
		'brzo',
		'bude',
		'budem',
		'budeme',
		'budes',
		'budete',
		'budeš',
		'budou',
		'budu',
		'by',
		'byl',
		'byla',
		'byli',
		'bylo',
		'byly',
		'bys',
		'byt',
		'být',
		'během',
		'chce',
		'chceme',
		'chcete',
		'chceš',
		'chci',
		'chtít',
		'chtějí',
		"chut'",
		'chuti',
		'ci',
		'clanek',
		'clanku',
		'clanky',
		'co',
		'coz',
		'což',
		'cz',
		'daleko',
		'dalsi',
		'další',
		'den',
		'deset',
		'design',
		'devatenáct',
		'devět',
		'dnes',
		'do',
		'dobrý',
		'docela',
		'dva',
		'dvacet',
		'dvanáct',
		'dvě',
		'dál',
		'dále',
		'děkovat',
		'děkujeme',
		'děkuji',
		'email',
		'ho',
		'hodně',
		'i',
		'jak',
		'jakmile',
		'jako',
		'jakož',
		'jde',
		'je',
		'jeden',
		'jedenáct',
		'jedna',
		'jedno',
		'jednou',
		'jedou',
		'jeho',
		'jehož',
		'jej',
		'jeji',
		'jejich',
		'její',
		'jelikož',
		'jemu',
		'jen',
		'jenom',
		'jenž',
		'jeste',
		'jestli',
		'jestliže',
		'ještě',
		'jež',
		'ji',
		'jich',
		'jimi',
		'jinak',
		'jine',
		'jiné',
		'jiz',
		'již',
		'jsem',
		'jses',
		'jseš',
		'jsi',
		'jsme',
		'jsou',
		'jste',
		'já',
		'jí',
		'jím',
		'jíž',
		'jšte',
		'k',
		'kam',
		'každý',
		'kde',
		'kdo',
		'kdy',
		'kdyz',
		'když',
		'ke',
		'kolik',
		'kromě',
		'ktera',
		'ktere',
		'kteri',
		'kterou',
		'ktery',
		'která',
		'které',
		'který',
		'kteři',
		'kteří',
		'ku',
		'kvůli',
		'ma',
		'mají',
		'mate',
		'me',
		'mezi',
		'mi',
		'mit',
		'mne',
		'mnou',
		'mně',
		'moc',
		'mohl',
		'mohou',
		'moje',
		'moji',
		'možná',
		'muj',
		'musí',
		'muze',
		'my',
		'má',
		'málo',
		'mám',
		'máme',
		'máte',
		'máš',
		'mé',
		'mí',
		'mít',
		'mě',
		'můj',
		'může',
		'na',
		'nad',
		'nade',
		'nam',
		'napiste',
		'napište',
		'naproti',
		'nas',
		'nasi',
		'načež',
		'naše',
		'naši',
		'ne',
		'nebo',
		'nebyl',
		'nebyla',
		'nebyli',
		'nebyly',
		'nechť',
		'nedělají',
		'nedělá',
		'nedělám',
		'neděláme',
		'neděláte',
		'neděláš',
		'neg',
		'nejsi',
		'nejsou',
		'nemají',
		'nemáme',
		'nemáte',
		'neměl',
		'neni',
		'není',
		'nestačí',
		'nevadí',
		'nez',
		'než',
		'nic',
		'nich',
		'nimi',
		'nove',
		'novy',
		'nové',
		'nový',
		'nula',
		'ná',
		'nám',
		'námi',
		'nás',
		'náš',
		'ní',
		'ním',
		'ně',
		'něco',
		'nějak',
		'někde',
		'někdo',
		'němu',
		'němuž',
		'o',
		'od',
		'ode',
		'on',
		'ona',
		'oni',
		'ono',
		'ony',
		'osm',
		'osmnáct',
		'pak',
		'patnáct',
		'po',
		'pod',
		'podle',
		'pokud',
		'potom',
		'pouze',
		'pozdě',
		'pořád',
		'prave',
		'pravé',
		'pred',
		'pres',
		'pri',
		'pro',
		'proc',
		'prostě',
		'prosím',
		'proti',
		'proto',
		'protoze',
		'protože',
		'proč',
		'prvni',
		'první',
		'práve',
		'pta',
		'pět',
		'před',
		'přede',
		'přes',
		'přese',
		'při',
		'přičemž',
		're',
		'rovně',
		's',
		'se',
		'sedm',
		'sedmnáct',
		'si',
		'sice',
		'skoro',
		'smí',
		'smějí',
		'snad',
		'spolu',
		'sta',
		'sto',
		'strana',
		'sté',
		'sve',
		'svych',
		'svym',
		'svymi',
		'své',
		'svých',
		'svým',
		'svými',
		'svůj',
		'ta',
		'tady',
		'tak',
		'take',
		'takhle',
		'taky',
		'takze',
		'také',
		'takže',
		'tam',
		'tamhle',
		'tamhleto',
		'tamto',
		'tato',
		'te',
		'tebe',
		'tebou',
		"ted'",
		'tedy',
		'tema',
		'ten',
		'tento',
		'teto',
		'ti',
		'tim',
		'timto',
		'tipy',
		'tisíc',
		'tisíce',
		'to',
		'tobě',
		'tohle',
		'toho',
		'tohoto',
		'tom',
		'tomto',
		'tomu',
		'tomuto',
		'toto',
		'trošku',
		'tu',
		'tuto',
		'tvoje',
		'tvá',
		'tvé',
		'tvůj',
		'ty',
		'tyto',
		'téma',
		'této',
		'tím',
		'tímto',
		'tě',
		'těm',
		'těma',
		'těmu',
		'třeba',
		'tři',
		'třináct',
		'u',
		'určitě',
		'uz',
		'už',
		'v',
		'vam',
		'vas',
		'vase',
		'vaše',
		'vaši',
		've',
		'vedle',
		'večer',
		'vice',
		'vlastně',
		'vsak',
		'vy',
		'vám',
		'vámi',
		'vás',
		'váš',
		'více',
		'však',
		'všechen',
		'všechno',
		'všichni',
		'vůbec',
		'vždy',
		'z',
		'za',
		'zatímco',
		'zač',
		'zda',
		'zde',
		'ze',
		'zpet',
		'zpravy',
		'zprávy',
		'zpět',
		'čau',
		'či',
		'článek',
		'článku',
		'články',
		'čtrnáct',
		'čtyři',
		'šest',
		'šestnáct',
		'že',
	],
	el: [
		'αλλα',
		'αν',
		'αντι',
		'απο',
		'αυτα',
		'αυτεσ',
		'αυτη',
		'αυτο',
		'αυτοι',
		'αυτοσ',
		'αυτουσ',
		'αυτων',
		'αἱ',
		'αἳ',
		'αἵ',
		'αὐτόσ',
		'αὐτὸς',
		'αὖ',
		'γάρ',
		'γα',
		'γε',
		'για',
		'γοῦν',
		'γὰρ',
		"δ'",
		'δέ',
		'δή',
		'δαί',
		'δαίσ',
		'δαὶ',
		'δαὶς',
		'δε',
		'δεν',
		"δι'",
		'διά',
		'διὰ',
		'δὲ',
		'δὴ',
		'δ’',
		'εαν',
		'ειμαι',
		'ειμαστε',
		'ειναι',
		'εισαι',
		'ειστε',
		'εκεινα',
		'εκεινεσ',
		'εκεινη',
		'εκεινο',
		'εκεινοι',
		'εκεινοσ',
		'εκεινουσ',
		'εκεινων',
		'ενω',
		'επ',
		'επι',
		'εἰ',
		'εἰμί',
		'εἰμὶ',
		'εἰς',
		'εἰσ',
		'εἴ',
		'εἴμι',
		'εἴτε',
		'η',
		'θα',
		'ισωσ',
		'κ',
		'καί',
		'καίτοι',
		'καθ',
		'και',
		'κατ',
		'κατά',
		'κατα',
		'κατὰ',
		'καὶ',
		'κι',
		'κἀν',
		'κἂν',
		'μέν',
		'μή',
		'μήτε',
		'μα',
		'με',
		'μεθ',
		'μετ',
		'μετά',
		'μετα',
		'μετὰ',
		'μη',
		'μην',
		'μἐν',
		'μὲν',
		'μὴ',
		'μὴν',
		'να',
		'ο',
		'οι',
		'ομωσ',
		'οπωσ',
		'οσο',
		'οτι',
		'οἱ',
		'οἳ',
		'οἷς',
		'οὐ',
		'οὐδ',
		'οὐδέ',
		'οὐδείσ',
		'οὐδεὶς',
		'οὐδὲ',
		'οὐδὲν',
		'οὐκ',
		'οὐχ',
		'οὐχὶ',
		'οὓς',
		'οὔτε',
		'οὕτω',
		'οὕτως',
		'οὕτωσ',
		'οὖν',
		'οὗ',
		'οὗτος',
		'οὗτοσ',
		'παρ',
		'παρά',
		'παρα',
		'παρὰ',
		'περί',
		'περὶ',
		'ποια',
		'ποιεσ',
		'ποιο',
		'ποιοι',
		'ποιοσ',
		'ποιουσ',
		'ποιων',
		'ποτε',
		'που',
		'ποῦ',
		'προ',
		'προσ',
		'πρόσ',
		'πρὸ',
		'πρὸς',
		'πως',
		'πωσ',
		'σε',
		'στη',
		'στην',
		'στο',
		'στον',
		'σόσ',
		'σύ',
		'σύν',
		'σὸς',
		'σὺ',
		'σὺν',
		'τά',
		'τήν',
		'τί',
		'τίς',
		'τίσ',
		'τα',
		'ταῖς',
		'τε',
		'την',
		'τησ',
		'τι',
		'τινα',
		'τις',
		'τισ',
		'το',
		'τοί',
		'τοι',
		'τοιοῦτος',
		'τοιοῦτοσ',
		'τον',
		'τοτε',
		'του',
		'τούσ',
		'τοὺς',
		'τοῖς',
		'τοῦ',
		'των',
		'τό',
		'τόν',
		'τότε',
		'τὰ',
		'τὰς',
		'τὴν',
		'τὸ',
		'τὸν',
		'τῆς',
		'τῆσ',
		'τῇ',
		'τῶν',
		'τῷ',
		'ωσ',
		"ἀλλ'",
		'ἀλλά',
		'ἀλλὰ',
		'ἀλλ’',
		'ἀπ',
		'ἀπό',
		'ἀπὸ',
		'ἀφ',
		'ἂν',
		'ἃ',
		'ἄλλος',
		'ἄλλοσ',
		'ἄν',
		'ἄρα',
		'ἅμα',
		'ἐάν',
		'ἐγώ',
		'ἐγὼ',
		'ἐκ',
		'ἐμόσ',
		'ἐμὸς',
		'ἐν',
		'ἐξ',
		'ἐπί',
		'ἐπεὶ',
		'ἐπὶ',
		'ἐστι',
		'ἐφ',
		'ἐὰν',
		'ἑαυτοῦ',
		'ἔτι',
		'ἡ',
		'ἢ',
		'ἣ',
		'ἤ',
		'ἥ',
		'ἧς',
		'ἵνα',
		'ὁ',
		'ὃ',
		'ὃν',
		'ὃς',
		'ὅ',
		'ὅδε',
		'ὅθεν',
		'ὅπερ',
		'ὅς',
		'ὅσ',
		'ὅστις',
		'ὅστισ',
		'ὅτε',
		'ὅτι',
		'ὑμόσ',
		'ὑπ',
		'ὑπέρ',
		'ὑπό',
		'ὑπὲρ',
		'ὑπὸ',
		'ὡς',
		'ὡσ',
		'ὥς',
		'ὥστε',
		'ὦ',
		'ᾧ',
	],
	ja: [
		'あそこ',
		'あの',
		'あの人',
		'あります',
		'ある',
		'あれ',
		'いう',
		'います',
		'いる',
		'いつ',
		'うち',
		'および',
		'おり',
		'おります',
		'かつて',
		'から',
		'ここ',
		'こちら',
		'こと',
		'この',
		'これ',
		'これら',
		'さらに',
		'しかし',
		'する',
		'せる',
		'そこ',
		'そして',
		'その',
		'その他',
		'その後',
		'それ',
		'それぞれ',
		'それで',
		'ただし',
		'たち',
		'ため',
		'たり',
		'だっ',
		'だれ',
		'でき',
		'できる',
		'です',
		'では',
		'でも',
		'という',
		'といった',
		'とき',
		'ところ',
		'として',
		'とともに',
		'とも',
		'と共に',
		'どこ',
		'どの',
		'ない',
		'なお',
		'なかっ',
		'ながら',
		'なく',
		'なっ',
		'など',
		'なに',
		'なら',
		'なり',
		'なる',
		'なん',
		'において',
		'における',
		'について',
		'にて',
		'によって',
		'により',
		'による',
		'に対して',
		'に対する',
		'に関する',
		'ので',
		'のみ',
		'ほか',
		'ほとんど',
		'ほど',
		'ます',
		'また',
		'または',
		'まで',
		'もの',
		'よう',
		'より',
		'られ',
		'られる',
		'れる',
		'何',
	],
	zh: [
		'一下',
		'一些',
		'一切',
		'一则',
		'一天',
		'一定',
		'一方面',
		'一旦',
		'一时',
		'一来',
		'一样',
		'一次',
		'一片',
		'一直',
		'一致',
		'一般',
		'一起',
		'一边',
		'一面',
		'万一',
		'上下',
		'上升',
		'上去',
		'上来',
		'上述',
		'上面',
		'下列',
		'下去',
		'下来',
		'下面',
		'不一',
		'不久',
		'不仅',
		'不会',
		'不但',
		'不光',
		'不单',
		'不变',
		'不只',
		'不可',
		'不同',
		'不够',
		'不如',
		'不得',
		'不怕',
		'不惟',
		'不成',
		'不拘',
		'不敢',
		'不断',
		'不是',
		'不比',
		'不然',
		'不特',
		'不独',
		'不管',
		'不能',
		'不要',
		'不论',
		'不足',
		'不过',
		'不问',
		'与其',
		'与否',
		'与此同时',
		'专门',
		'两者',
		'严格',
		'严重',
		'个人',
		'个别',
		'中小',
		'中间',
		'丰富',
		'为主',
		'为了',
		'为什么',
		'为什麽',
		'为何',
		'为着',
		'主张',
		'主要',
		'举行',
		'乃至',
		'之一',
		'之前',
		'之后',
		'之後',
		'之所以',
		'之类',
		'乌乎',
		'也好',
		'也是',
		'也罢',
		'了解',
		'争取',
		'于是',
		'于是乎',
		'云云',
		'互相',
		'产生',
		'人们',
		'人家',
		'什么',
		'什么样',
		'什麽',
		'今后',
		'今天',
		'今年',
		'今後',
		'仍然',
		'从事',
		'从而',
		'他人',
		'他们',
		'他的',
		'代替',
		'以上',
		'以下',
		'以为',
		'以便',
		'以免',
		'以前',
		'以及',
		'以后',
		'以外',
		'以後',
		'以来',
		'以至',
		'以至于',
		'以致',
		'任何',
		'任凭',
		'任务',
		'企图',
		'伟大',
		'似乎',
		'似的',
		'但是',
		'何',
		'何况',
		'何处',
		'何时',
		'作为',
		'你们',
		'你的',
		'使得',
		'使用',
		'例如',
		'依照',
		'依靠',
		'促进',
		'保持',
		'俺们',
		'倘使',
		'倘或',
		'倘然',
		'倘若',
		'假使',
		'假如',
		'假若',
		'做到',
		'允许',
		'充分',
		'先后',
		'先後',
		'先生',
		'全部',
		'全面',
		'共同',
		'关于',
		'其一',
		'其中',
	],
	ko: [
		'가까스로',
		'가령',
		'각각',
		'각자',
		'각종',
		'갖고말하자면',
		'같다',
		'같이',
		'개의치않고',
		'거니와',
		'거바',
		'거의',
		'것들',
		'게다가',
		'게우다',
		'겨우',
		'견지에서',
		'결국',
		'겸사겸사',
		'고려하면',
		'고로',
		'공동으로',
		'과연',
		'관계없이',
		'관하여',
		'관한',
		'관해서는',
		'구체적으로',
		'구토하다',
		'그들',
		'그때',
		'그래',
		'그래도',
		'그래서',
		'그러나',
		'그러니',
		'그러니까',
		'그러면',
		'그러므로',
		'그러한즉',
		'그런데',
		'그런즉',
		'그럼',
		'그렇지',
		'그렇지만',
		'그렇지않으면',
		'그리고',
		'그리하여',
		'그만이다',
		'그위에',
		'그저',
		'그중에서',
		'근거로',
		'근거하여',
		'기대여',
		'기점으로',
		'기준으로',
		'기타',
		'까닭으로',
		'까악',
		'까지',
		'까지도',
		'꽈당',
	],
};

// combined lists below make the complete list of languages we currently support for query processing
export const languagesWithSpaces = ['en', 'de', 'ru', 'fr', 'pt', 'cs', 'el'];
export const languagesWithoutSpaces = ['zh', 'ja', 'ko'];
